import { Editor } from '@tiptap/react';

export const OPEN_MEMO_REPORT_COMPONENT_PICKER_EVENT = 'countercyclical:memo:open-report-component-picker';

export interface OpenMemoReportComponentPickerEventDetail {
    editor: Editor;
}
